import { TRAVEL_FLOW_INBOUND, TRAVEL_FLOW_OUTBOUND } from '@/shared/constants/flow.constants'
import type { useFlowResult } from './useFlow.types'
import { type RouteLocationNormalizedLoaded, useRoute } from 'vue-router'
import { TravelDirection } from '@/shared/types/common.types'
import type { AvailableFlowRoutes } from '@/shared/types/flow.types'

export const useFlow = (
  routeIfCallNotFromSetupFunction?: RouteLocationNormalizedLoaded
): useFlowResult => {
  // useRouter() can only be called from the `setup` function inside the component, if you call it from elsewhere (from store or hooks) it will return `undefined`. This is why it sometimes necessary to manually pass the `route`. '

  // Function argument specifically has an unusal name as `routeIfCallNotFromSetupFunction`, to understand why we need this, because it is a hack.

  const route = routeIfCallNotFromSetupFunction ?? useRoute()

  let flowDirection: TravelDirection
  let flowScheme: AvailableFlowRoutes[]

  if (!route) {
    console.error(
      'Route is undefined. Call useFlow() insude of `setup` function or pass route instance manually.'
    )
    flowDirection = TravelDirection.UNKNOWN
    flowScheme = []
  } else {
    const hasOutboundFlow = !!route?.matched?.find((r) => r.name === TravelDirection.OUTBOUND)
    const hasInboundFlow = !!route?.matched?.find((r) => r.name === TravelDirection.INBOUND)

    if (hasOutboundFlow) {
      flowDirection = TravelDirection.OUTBOUND
      flowScheme = TRAVEL_FLOW_OUTBOUND
    } else if (hasInboundFlow) {
      flowDirection = TravelDirection.INBOUND
      flowScheme = TRAVEL_FLOW_INBOUND
    } else {
      flowDirection = TravelDirection.UNKNOWN
      flowScheme = []
    }
  }

  return {
    flowScheme,
    flowDirection,
  }
}
